import hljs from 'highlight.js';
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import createTipPlugin from '@kangc/v-md-editor/lib/plugins/tip/index';
import '@kangc/v-md-editor/lib/plugins/tip/tip.css';
import createTodoListPlugin from '@kangc/v-md-editor/lib/plugins/todo-list/index';
import '@kangc/v-md-editor/lib/plugins/todo-list/todo-list.css';
import ReplaceLinkPlugin from './replacelink';
import PropsPlugin from './props';

export const replaceLinkPlugin = new ReplaceLinkPlugin();
export const propsPlugin = new PropsPlugin();

replaceLinkPlugin.setReplace((key) => {
  if (`${key}`.indexOf('#') == 0) {
    let keyword = `${key}`.substring(1);
    return `http://www.baidu.com/s?wd=${keyword}`
  }
  return key;
})

VueMarkdownEditor.use(createTipPlugin());
VueMarkdownEditor.use(createTodoListPlugin());
VueMarkdownEditor.use(replaceLinkPlugin);
VueMarkdownEditor.use(propsPlugin);
VueMarkdownEditor.use(githubTheme, { Hljs: hljs });

export function getLeftToolBar() {
  let customPlugin = '';
  if (propsPlugin.isEnable()) {
    customPlugin += 'props ';
  }
  if (replaceLinkPlugin.isEnable()) {
    customPlugin += 'replace-link ';
  }
  if (customPlugin) {
    customPlugin += '| ';
  }
  let toolbar = `undo redo clear | `;
  toolbar += `tip h bold italic strikethrough quote | `;
  toolbar += `todo-list ul ol table hr | `;
  toolbar += customPlugin;
  toolbar += `image link code | `;
  toolbar += `preview sync-scroll fullscreen`;
  return toolbar
}

export const MarkdownEditor = VueMarkdownEditor;